import { Action } from 'redux';
import { AUTHENTICATION_CLEAR_TOKEN } from '../authenticationConstants';

export interface IStoreAuthenticationClearTokenAction extends Action {
  type: typeof AUTHENTICATION_CLEAR_TOKEN;
}

export function authenticationClearTokenAction(): IStoreAuthenticationClearTokenAction {
  return {
    type: AUTHENTICATION_CLEAR_TOKEN,
  };
}
